module.exports = __webpack_public_path__ + "assets/img/8c66166716cd8fb552b488af71c45ec3.png";